import styled, { css } from "styled-components";
import { useDispatch, useSelector } from "react-redux";

import { actions } from "reducers/redux/data";
import { typography } from "globalConstants";
import { email as iconEmail, addFile as iconAddFile } from "images";
import { ReduxStates } from "Types";
import { Data as DataType } from "Types/Reducers";

import AtomH2 from "Components/Atoms/H2";
import AtomFile from "Components/Atoms/FileInput";
import AtomPaper from "Components/Atoms/Paper";

export type PropsType = any;

const Wrap = styled(AtomPaper)``;

const Text = styled.div<any>`
   ${typography.other.t8};
   display: flex;
   flex-direction: row;
   align-items: center;
   margin-top: 9px;
   ${({ css }) => css}
`;
const Purple = styled.span`
   color: ${typography.other.color.purple[0]};
   display: inline;
`;
const SubTitle = styled.span`
   ${typography.other.t7}
   display: inline;
`;

const cssPadding = css`
   padding-left: 15px;
`;
const Dot = styled.span`
   display: flex;
   flex-direction: row;
   align-items: center;
   width: 15px;
   box-sizing: border-box;
   padding-left: 5px;
   &:after {
      content: "";
      width: 4px;
      height: 4px;
      border-radius: 50%;
      background-color: black;
   }
`;
const FileWrap = styled(AtomPaper)`
   margin-top: 10px;
   padding: 28px 0px 16px 0px;
`;

function EmailContainer() {
   const Wrap = styled.div`
      display: flex;
      flex-direction: row;
      align-items: center;
      ${cssPadding}
   `;
   const Icon = styled.img`
      display: block;
      height: 12px;
   `;
   const Text = styled.div`
      ${typography.other.t6}
      margin-left: 12px;
      color: ${typography.other.color.gray[0]};
   `;

   return (
      <Wrap>
         <Icon src={iconEmail}></Icon>
         <Text>contact@art-map.co.kr</Text>
      </Wrap>
   );
}

function FileContainer() {
   const Wrap = styled.div`
      display: flex;
      flex-direction: column;
      align-items: center;
      row-gap: 15px;
   `;
   const Text = styled.div`
      ${typography.other.t9}
      color: ${typography.other.color.gray[0]};
   `;
   const Img = styled.img`
      height: 40px;
   `;
   return (
      <Wrap>
         <Img src={iconAddFile}></Img>
         <Text>파일 드래그 또는 아이콘 클릭하여 업로드</Text>
      </Wrap>
   );
}

export default function OrganismForm3(props: PropsType) {
   const dispatch = useDispatch();
   const data = useSelector((state: any) => state.data);

   const tempFiles: any = [];

   function fileOnUpload(parameters: any) {
      console.log("upload complete ", parameters);
      try {
         const result = JSON.parse(parameters);
         // eslint-disable-next-line eqeqeq
         if (result.code == 200) {
            tempFiles.push(result.data);
            dispatch({
               type: actions.set,
               payload: {
                  ...data,
                  temp_files: [...data.temp_files, ...tempFiles],
               },
            });
         } else {
            console.error(parameters);
         }
      } catch (err) {
         console.error(err, parameters);
      }
   }
   console.log("data", data);
   return (
      <Wrap className={props.className} style={props.style} css={props.css}>
         <AtomH2>3. 첨부파일 업로드</AtomH2>
         <Text
            css={css`
               margin-top: 24px;
            `}>
            <Purple>[자료 목록]</Purple>
         </Text>
         <Text>
            <Dot></Dot> <Purple>*</Purple>전시 포스터
         </Text>
         <Text>
            <Dot></Dot> <Purple>*</Purple>전시 소개용 텍스트(전시 서문 등)
         </Text>
         <Text>
            <Dot></Dot> <Purple>*</Purple>전시 전경 / 작품 이미지
         </Text>
         <Text
            css={css`
               margin-top: 20px;
            `}>
            <Purple>[확인사항]</Purple>
         </Text>
         <Text>
            <Dot></Dot> 하나의 압축 파일로 올려주십시오.
         </Text>
         <Text>
            <Dot></Dot> 작품이미지 파일 명, 캡션 정보 기입 해주십시오.
         </Text>
         <Text css={cssPadding}>파일 명 예시) 작품명_작가명_재료_사이즈_연도</Text>
         <Text css={cssPadding}>또는 작품 정보 워드 파일, 텍스트 파일 함께 첨부 바랍니다.</Text>

         <Text>
            <Dot></Dot> 30MB 이상의 용량일 경우, 아래 메일 주소로 보내 주십시오
         </Text>
         <Text>
            <EmailContainer></EmailContainer>
         </Text>
         <Text
            css={css`
               margin-top: 26px;
            `}>
            <SubTitle>파일 업로드</SubTitle>
         </Text>
         <FileWrap>
            <AtomFile
               files={data.temp_files.map((file: any) => ({
                  source: file,
                  options: {
                     type: "local",
                  },
               }))}
               onComplete={fileOnUpload}>
               <FileContainer></FileContainer>
            </AtomFile>
         </FileWrap>
      </Wrap>
   );
}
